export default __webpack_public_path__ + "static/media/instagram.cb78402d.svg";